// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.response_response__vJbBW {
    border: 1px solid #707070;
    background: #fff;
    padding: 36px 12px;

    display: flex;
    align-items: center;
    font-size: 20px;
    width: 485px;
    cursor: pointer;
}

.response_fixed__UfZv1 {
    position: fixed;
    z-index: 126;
    top: 34px;
    right: 18px;
}

.response_aligned__PzCFv {
    position: relative;
    margin: auto;
}

.response_response__vJbBW span {
    display: block;
    margin: auto 0 auto 16px;
}

.response_error__smiiP {
    color: var(--alert-color);
    border-color: var(--alert-color);
}

.response_success__e\\+dVI {
    color: var(--success-color);
}

.response_response__vJbBW button {
    background: transparent;
    position: absolute;
    top: 12px;
    right: 13px;
    border: 0;
    padding: 0;
    height: 14px;
    width: 14px;
}

.response_response__vJbBW button:before,
.response_response__vJbBW button:after {
    content: '';
    display: block;
    width: 14px;
    height: 1px;
    background: #707070;
    transform-origin: center;
    position: absolute;
    top: 50%;
    left: 0;
    margin: auto;
}

.response_response__vJbBW button:before {
    transform: rotate(45deg);
}

.response_response__vJbBW button:after {
    transform: rotate(-45deg);
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .response_response__vJbBW {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Response/response.module.css"],"names":[],"mappings":"AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.response {\n    border: 1px solid #707070;\n    background: #fff;\n    padding: 36px 12px;\n\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    width: 485px;\n    cursor: pointer;\n}\n\n.fixed {\n    position: fixed;\n    z-index: 126;\n    top: 34px;\n    right: 18px;\n}\n\n.aligned {\n    position: relative;\n    margin: auto;\n}\n\n.response span {\n    display: block;\n    margin: auto 0 auto 16px;\n}\n\n.error {\n    color: var(--alert-color);\n    border-color: var(--alert-color);\n}\n\n.success {\n    color: var(--success-color);\n}\n\n.response button {\n    background: transparent;\n    position: absolute;\n    top: 12px;\n    right: 13px;\n    border: 0;\n    padding: 0;\n    height: 14px;\n    width: 14px;\n}\n\n.response button:before,\n.response button:after {\n    content: '';\n    display: block;\n    width: 14px;\n    height: 1px;\n    background: #707070;\n    transform-origin: center;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    margin: auto;\n}\n\n.response button:before {\n    transform: rotate(45deg);\n}\n\n.response button:after {\n    transform: rotate(-45deg);\n}\n\n@media screen-md-max {\n    .response {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"response": `response_response__vJbBW`,
	"fixed": `response_fixed__UfZv1`,
	"aligned": `response_aligned__PzCFv`,
	"error": `response_error__smiiP`,
	"success": `response_success__e+dVI`
};
export default ___CSS_LOADER_EXPORT___;
